<template>
    <x-page title="Add Jemaat">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>

        <ul id="member-tabs" class="nav nav-tabs">
            <li role="presentation" class="active">
                <a href="#member-detail" aria-controls="member-detail" role="tab" data-toggle="tab">Biodata</a>
            </li>
        </ul>

        <div class="tab-content" style="padding-top:10px;">
            <div role="tabpanel" class="tab-pane fade in active" id="member-detail">
                <member-form id="member-form"
                    :enable-name-check="true"
                    @submit="handleSubmit"
                    :initialFields="initialFields"
                    :disabled="isLoading"
                    :errors="errors" />
            </div>
        </div>

        <template #footer>
            <x-submit-button form="member-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { dateFormat } from '../../constants'
import { handleValidationXhrError } from '../../helpers'
import MemberForm from './MemberForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        MemberForm,
    },
    data() {
        return {
            errors: null,
            initialFields: {
                join_date: moment().format(dateFormat),
            },
            isLoading: false,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/members`, fields, {
                headers: {
					'Content-Type': 'multipart/form-data'
				}
            })
            .then((response) => {
                this.$notify({
                    type: 'success',
                    title: `Berhasil`,
                    text: `${response.data.data.name} added!`,
                })
                this.$router.back()
            })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        }
    },
}
</script>